var home = (function () {
    interface IHomeViewModel {
        showWorkbooksMode: KnockoutObservable<ShowWorkbooksModeEnum>;
        showTabs: KnockoutObservable<boolean>;
        showWorkbooksType: KnockoutObservable<ShowWorkbooksTypeEnum>;
        grouping: KnockoutObservable<HomeWorkbookGroupingEnum>;
        sortColumn: KnockoutObservable<any>;
        sortOrder: KnockoutObservable<any>;
        sortByFavoriteOrder: KnockoutObservable<boolean>;
        editFavoriteOrder: KnockoutObservable<boolean>;
        filterByEmail: KnockoutObservable<boolean>;

        gridConfig: DevExpress.ui.dxDataGrid.Properties,
        gridComponent: DevExpress.ui.dxDataGrid;
    }

    var getCompanyId = function () {
        let span = $("span#companySelected");
        if (span.length > 0) {
            return parseInt(span[0].dataset.id, 10);
        }
        return -1;
    }

    let updateGridTitle = function (vm) {
        let view = vm.showWorkbooksMode() == ShowWorkbooksModeEnum.Recent ? "Recent" : vm.showWorkbooksMode() == ShowWorkbooksModeEnum.Favorites ? "Favorite" : "All";
        let mobileDevice = isMobile();
        let owner = "";
        let groupedBy = "";
        if (!mobileDevice) {
            owner = vm.showWorkbooksType() == ShowWorkbooksTypeEnum.Mine ? " (Mine)" : vm.showWorkbooksType() == ShowWorkbooksTypeEnum.OtherUsers ? " (Other Users)" : "";
            groupedBy = vm.grouping() === HomeWorkbookGroupingEnum.None ? "" : ` by ${vm.grouping()}`;
            $("span.title").text(`${view} Workbooks${groupedBy}${owner}`);
        }
        else {
            owner = vm.showWorkbooksType() == ShowWorkbooksTypeEnum.Mine ? " (Mine)" : vm.showWorkbooksType() == ShowWorkbooksTypeEnum.OtherUsers ? " (Others)" : "";
            if (view !== "All") {
                view += "s";
            }
            else {
                if (owner === "") {
                    view += " Workbooks";
                }
            }
            $("span.title").text(`${view}${owner}`);
        }
    }

    let rowEditing = null;
    var setup = function () {
        if (performance && performance.navigation.type == 2) {
            location.reload();
        }

        irGlobal.setup();
        irGlobal.setupChangePassword();

        let showMappingPopover = null;
        ko.applyBindings({
            onMappingClick: function (id: number, name: string) {
                document.location.href = `${urlConfigs.tabs}new/${id}`;
            },
            callback: function (obj) {
                showMappingPopover = obj.show;
            }
        }, $("select-mapping-popover").get(0));     

        let showCompanyPopover = null;
        ko.applyBindings({
            onCompanyClick: function (id: number, name: string) {
                document.location.href = `${urlConfigs.siteRoot}home/home/?companyId=${id}`;
            },
            callback: function (obj) {
                showCompanyPopover = obj.show;
            }
        }, $("select-company-popover").get(0));

        let json = $(".homeContent").data("json");
        json.workbooks = json.workbooks.map(obj => {
            return { ...obj, lastViewedDate: obj.lastViewed ? new Date(obj.lastViewed) : null, tabsName: obj.workbook.tabs.map(t => t.name).toString() };
        });
        if (json.showWorkbooksMode === ShowWorkbooksModeEnum.Recent && json.workbooks.filter(x => x.lastViewedDate).length === 0) {
            json.showWorkbooksMode = ShowWorkbooksModeEnum.All;
        }

        let getDataSource = function () {
            let ouput = [];

            switch (vm.showWorkbooksMode()) {
                case ShowWorkbooksModeEnum.Recent:
                    ouput = json.workbooks.filter(x => x.lastViewedDate).sort((a, b) => b.lastViewedDate - a.lastViewedDate).slice(0, 10);
                    break;
                case ShowWorkbooksModeEnum.Favorites:
                    ouput = json.workbooks.filter(x => x.workbook.favorite);
                    break;
                default:
                    ouput = json.workbooks;
                    break;
            }

            if (vm.filterByEmail()) {
                ouput = ouput.filter(x => x.hasEmails);
            }

            return ouput;
        }

        let mobileDevice = isMobile();

        const viewGroupName = "View";
        const ownerGroupName = "Owners";
        const groupByGroupName = "Group By";
        let menuList = [
            {
                key: "Actions",
                icon: "eyeopen",
                items: [
                    {
                        key: 101, name: "New Workbook", icon: "add", visible: (loggedUser.permissions.createWorkbooks()) && !mobileDevice,
                    },
                    {
                        key: 102, name: json.company?.name, icon: "tags", visible: json.enableMultiTenant,
                        template: `<span class="material-icons changeCompanyIcon">apartment</span><span>${json.company?.name}</span>`
                    },
                    {
                        key: 103, name: "Admin", icon: "preferences", visible: !mobileDevice && json.enableAdmin,
                        template: '<span class="material-icons">admin_panel_settings</span><span>Admin</span>'
                    },
                ],
            },
            {
                key: viewGroupName,
                icon: "eyeopen",
                items: [
                    {
                        key: 1, name: "Recent", icon: "clock", badge: json.workbooks.filter(x => x.lastViewedDate).sort((a, b) => b.lastViewedDate - a.lastViewedDate).slice(0, 10).length,
                        template: '<span id="itemElement-1" class="material-icons">schedule</span><span>Recent</span>',
                        visible: json.workbooks.filter(x => x.lastViewedDate).length > 0
                    },
                    {
                        key: 2, name: "Favorites", icon: "favorites", badge: json.workbooks.filter(x => x.workbook.favorite).length,
                        template: '<span id="itemElement-2" class="material-icons">star</span><span>Favorites</span>'
                    },
                    {
                        key: 3, name: "All", icon: "detailslayout", badge: json.workbooks.length,
                        template: '<span id="itemElement-3" class="material-icons">format_align_justify</span><span>All</span>'
                    },
                ],
            },
            {
                key: ownerGroupName,
                icon: "user",
                items: [
                    { key: 11, name: "All", icon: "group", template: '<span class="material-icons">groups</span><span>All</span>', },
                    { key: 12, name: "Mine", icon: "card", template: '<span class="material-icons">person</span><span>Mine</span>' },
                    { key: 13, name: "Others", icon: "user", template: '<span class="material-icons">share</span><span>Others</span>' },
                ]
            },
            {
                key: groupByGroupName,
                icon: "alignleft",
                items: [
                    {
                        key: 21, name: "None", icon: "contentlayout", template: '<span class="material-icons">format_align_justify</span><span>None</span>'
                    },
                    {
                        key: 22, name: "Mapping", icon: "columnchooser", template: '<span id="itemElement-22" class="material-icons" data-icon="">account_tree</span><span>Mapping</span>',
                        disabled: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites
                    },
                    {
                        key: 23, name: "Owner", icon: "user", template: '<span id="itemElement-23" class="material-icons">person</span><span>Owner</span>',
                        disabled: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites
                    },
                    {
                        key: 24, name: "Category", icon: "pin", template: '<span id="itemElement-24" class="material-icons">category</span><span>Category</span>',
                        disabled: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites
                    },
                ]
            },
            {
                key: "Options",
                icon: "alignleft",
                items: [
                    { key: 31, name: "Show/Hide Tabs", icon: "inactivefolder", template: '<span class="material-icons">tab</span><span>Show/Hide Tabs</span>', visible: !isMobile() }
                ]
            },
        ];

        let selectedItemKeys = [
            json.showWorkbooksMode === ShowWorkbooksModeEnum.All ? 3 : (json.showWorkbooksMode === ShowWorkbooksModeEnum.Recent ? 1 : 2),
            json.showWorkbooksType === ShowWorkbooksTypeEnum.All ? 11 : (json.showWorkbooksType === ShowWorkbooksTypeEnum.Mine ? 12 : 13),
            menuList.find(x => x.key === "Group By").items.find(x => x.name === json.grouping).key,
        ];

        if (json.showTabs) {
            selectedItemKeys.push(31);
        }

        let menuListControl;
        let drawer = $('#drawer').dxDrawer({
            revealMode: "slide",
            //overlap if it is a mobile device or small screen
            openedStateMode: !mobileDevice ? "shrink" : "overlap",
            opened: !mobileDevice,
            closeOnOutsideClick: mobileDevice,
            template: function (e) {
                var $template = $(`<div style="height: calc(100vh - 34px -50px);"><div class="list"></div></div>`);

                menuListControl = $template.dxList({
                    dataSource: menuList,
                    keyExpr: "key",
                    itemTemplate: function (e) {
                        let iconName = `dx-icon-${e.icon}`
                        let icon = e.icon ? `<i class="${iconName}"></i> ` : "";

                        return $(`${icon}<span>${e.name}</span>`);
                    },
                    width: 160,
                    height: "100%",
                    selectByClick: false,
                    selectionMode: "multiple",
                    selectedItemKeys: selectedItemKeys,
                    elementAttr: { class: "dx-theme-accent-as-background-color" },
                    searchExpr: ["name", "items.name"],
                    displayExpr: "name",
                    grouped: true,
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    onItemClick(e) {
                        if (e.itemIndex && (e.itemIndex as any).group >= 1 && (e.itemIndex as any).group <= 3) {
                            let groupName = "";
                            switch ((e.itemIndex as any).group) {
                                case 1:
                                    groupName = viewGroupName;
                                    break;
                                case 2:
                                    groupName = ownerGroupName;
                                    break;
                                case 3:
                                    groupName = groupByGroupName;
                                    break;
                            }
                            $(".dx-list-group-header span", e.itemElement.closest(".dx-list-group")).html(`${groupName}: ${e.itemData.name}`);
                        }
                        let closeMenu = mobileDevice;
                        let dataGrid1 = $("#homeWorkbookGrid").dxDataGrid("instance");

                        if (e.itemData.key < 30) {

                            let groupIndex = {
                                group: (e.itemIndex as any).group,
                                item: 0,
                            };
                            for (let item of menuList[(e.itemIndex as any).group].items) {
                                menuListControl.unselectItem(groupIndex);
                                groupIndex.item++;
                            }
                            menuListControl.selectItem(e.itemIndex);
                        }

                        let onGroupByNoneChanged = function () {
                            let indexItem = 0;
                            switch (vm.grouping()) {
                                case HomeWorkbookGroupingEnum.Category:
                                    indexItem = 3;
                                    break;
                                case HomeWorkbookGroupingEnum.Owner:
                                    indexItem = 2;
                                    break;
                                case HomeWorkbookGroupingEnum.Mapping:
                                    indexItem = 1;
                                    break;
                            }
                            menuListControl.unselectItem({ group: 3, item: indexItem });
                            vm.grouping(HomeWorkbookGroupingEnum.None);
                            dataGrid1.clearGrouping();
                            dataGrid1.option("toolbar.items[0].options.visible", false);
                            menuListControl.selectItem({ group: 3, item: 0 });
                        }

                        switch (e.itemData.key) {
                            //View - Recent
                            case 1:
                                vm.showWorkbooksMode(ShowWorkbooksModeEnum.Recent);
                                updateViewBadge();

                                let ds1 = getDataSource();
                                dataGrid1.option("dataSource", ds1);

                                dataGrid1.option("toolbar.items[1].options.visible", false);
                                dataGrid1.option("toolbar.items[2].options.visible", false);

                                $("span#itemElement-24, span#itemElement-23, span#itemElement-22").closest(".dx-item.dx-list-item").removeClass("dx-state-disabled");
                                break;
                            //View - Favorites
                            case 2:
                                vm.showWorkbooksMode(ShowWorkbooksModeEnum.Favorites);
                                updateViewBadge();

                                let ds2 = getDataSource();
                                dataGrid1.option("dataSource", ds2);

                                onGroupByNoneChanged();

                                dataGrid1.option("toolbar.items[1].options.visible", true);
                                dataGrid1.option("toolbar.items[2].options.visible", true);

                                $("span#itemElement-24, span#itemElement-23, span#itemElement-22").closest(".dx-item.dx-list-item").addClass("dx-state-disabled");
                                break;
                            //View - All Workbooks
                            case 3:
                                vm.showWorkbooksMode(ShowWorkbooksModeEnum.All);
                                updateViewBadge();

                                let ds3 = getDataSource();
                                dataGrid1.option("dataSource", ds3);

                                dataGrid1.option("toolbar.items[1].options.visible", false);
                                dataGrid1.option("toolbar.items[2].options.visible", false);

                                $("span#itemElement-24, span#itemElement-23, span#itemElement-22").closest(".dx-item.dx-list-item").removeClass("dx-state-disabled");
                                break;
                            //Owner - All
                            case 11:
                                vm.showWorkbooksType(ShowWorkbooksTypeEnum.All);
                                dataGrid1.option("filterValue", undefined);
                                break;
                            //Owner - Mine
                            case 12:
                                vm.showWorkbooksType(ShowWorkbooksTypeEnum.Mine);
                                dataGrid1.option("filterValue", ['ownerId', '=', `${loggedUser.id()}`]);
                                break;
                            //Owner - Others
                            case 13:
                                if (loggedUser.permissions.workbooks()) {
                                    vm.showWorkbooksType(ShowWorkbooksTypeEnum.OtherUsers);
                                    dataGrid1.option("filterValue", ['ownerId', '<>', `${loggedUser.id()}`]);
                                }
                                else {
                                    vm.showWorkbooksType(ShowWorkbooksTypeEnum.Shared);
                                    dataGrid1.option("filterValue", ['editMode', '<>', '1']);
                                }
                                break;
                            //Group By - None
                            case 21:
                                onGroupByNoneChanged();
                                break;
                            //Group By - Mapping
                            case 22:
                                vm.grouping(HomeWorkbookGroupingEnum.Mapping);
                                dataGrid1.clearGrouping();
                                dataGrid1.columnOption("mappingName", 'groupIndex', 0);
                                dataGrid1.option("toolbar.items[0].options.visible", true);

                                vm.editFavoriteOrder(false);
                                menuListControl.unselectItem({ group: 4, item: 2 });//unselect favorites order
                                break;
                            //Group By - Owner
                            case 23:
                                vm.grouping(HomeWorkbookGroupingEnum.Owner);
                                dataGrid1.clearGrouping();
                                dataGrid1.columnOption("ownerUserName", 'groupIndex', 0);
                                dataGrid1.option("toolbar.items[0].options.visible", true);

                                vm.editFavoriteOrder(false);
                                menuListControl.unselectItem({ group: 4, item: 2 });//unselect favorites order
                                break;
                            //Group By - Category
                            case 24:
                                vm.grouping(HomeWorkbookGroupingEnum.Category);
                                dataGrid1.clearGrouping();
                                dataGrid1.columnOption("categoryName", 'groupIndex', 0);
                                dataGrid1.option("toolbar.items[0].options.visible", true);

                                vm.editFavoriteOrder(false);
                                menuListControl.unselectItem({ group: 4, item: 2});//unselect favorites order
                                break;
                            //Options - Show Tabs
                            case 31:
                                vm.showTabs(!vm.showTabs());
                                if (vm.showTabs()) {
                                    menuListControl.selectItem(e.itemIndex);
                                }
                                else {
                                    menuListControl.unselectItem(e.itemIndex);
                                }
                                dataGrid1.refresh();
                                break;
                            //Options - Edit favorite order
                            case 32:
                                if (vm.showWorkbooksMode() == ShowWorkbooksModeEnum.Favorites) {
                                    if (vm.showWorkbooksMode() == ShowWorkbooksModeEnum.Favorites) {
                                        //isItemSelected
                                        vm.editFavoriteOrder(!vm.editFavoriteOrder());
                                        if (vm.editFavoriteOrder()) {
                                            menuListControl.selectItem(e.itemIndex);
                                        }
                                        else {
                                            menuListControl.unselectItem(e.itemIndex);
                                        }
                                    }
                                }
                                break;
                            //Options: - Sort by favorite order
                            case 33:
                                if (vm.showWorkbooksMode() == ShowWorkbooksModeEnum.Favorites) {
                                    //isItemSelected
                                    vm.sortByFavoriteOrder(!vm.sortByFavoriteOrder());
                                    if (vm.sortByFavoriteOrder()) {
                                        menuListControl.selectItem(e.itemIndex);
                                    }
                                    else {
                                        menuListControl.unselectItem(e.itemIndex);
                                    }
                                }
                                break;
                            //Actions - New Workbook
                            case 101:
                                showMappingPopover(e.itemElement);
                                break;
                            //Actions - Company
                            case 102:
                                closeMenu = false;
                                showCompanyPopover(e.itemElement);
                                break;
                            //Actions - Admin
                            case 103:
                                window.location.href = '/admin';
                                break;
                        }

                        updateGridTitle(vm);

                        if (closeMenu) {
                            drawer.hide();
                        }
                    },
                    collapsibleGroups: true,
                    groupTemplate(data) {
                        let selectedItem = null;
                        if (data.items && data.key !== "Actions" && data.key !== "Options") {
                            let selectedItems = this.option("selectedItemKeys");
                            data.items.forEach(function (item) {
                                if (selectedItems.indexOf(item.key) !== -1) {
                                    selectedItem = item;
                                }
                            });
                        }

                        return $(`<span>${data.key}${(selectedItem ? `: ${selectedItem.name}` : "")}</span>`);
                    },
                    onGroupRendered: function (e) {
                        if (e.groupIndex > 1)
                            e.component.collapseGroup(e.groupIndex);
                    },
                }).dxList('instance');

                return $template;
            },
            height: "calc(100% - 40px)",
        }).dxDrawer('instance');

        let customerLogoImg = "";
        if (json.customerLogo) {
            customerLogoImg = `<img src="${json.customerLogo}" style={ max-height="32px" max-width="120px"/>`;
        }

        let toolbarControl = $('#toolbar').dxToolbar({
            elementAttr: {
                class: 'dx-theme-background-color',
            },
            items: [
                {
                    location: 'before',
                    html: `<img src="${urlConfigs.logoSmall}" height="32px" width="32px" style="margin-top: -2px;"/>`,
                },
                {
                    widget: 'dxButton',
                    location: 'before',
                    options: {
                        icon: 'menu',
                        stylingMode: 'text',
                        onClick() {
                            drawer.toggle();
                        },
                    },
                },
                {
                    location: 'before',
                    html: `<div  style="display: flex; align-items: center;">${customerLogoImg}<span class="customer" style="vertical-align: super; max-width: 250px;">${json.customerName}</span></div>`,
                    visible: !mobileDevice,
                },
                {
                    location: 'center',
                    html: `<div style=""><span class="title">Workbooks</span></div>`,
                    width: 200,
                },
                {
                    location: 'after',
                    widget: 'dxMenu',
                    options: {
                        cssClass: "homeContent userLoginPopup",
                        height: 26,
                        items: [{
                            name: json.userInitials,
                            items: [
                                {
                                    name: json.username,
                                    html: '<span class="material-icons">person</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Profile: ' + json.userProfile,
                                    html: '<span class="material-icons">badge</span>',
                                },
                                {
                                    name: 'Organization: ' + json.userOrganization,
                                    html: '<span class="material-icons">corporate_fare</span>',
                                },
                                {
                                    name: 'Locale: ' + loggedUser.locale(),
                                    html: '<span class="material-icons">public</span>',
                                },
                                {
                                    name: 'Time Zone: ' + loggedUser.timeZone(),
                                    html: '<span class="material-icons">schedule</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Interactive Reporting',
                                    html: '<span class="material-icons">equalizer</span>',
                                },
                                {
                                    name: 'Version: ' + json.version,
                                    html: '<span class="material-icons">info</span>',
                                },
                                {
                                    name: 'Date: ' + json.date,
                                    html: '<span class="material-icons">description</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Change Password',
                                    html: '<span class="material-icons">password</span>',
                                    visible: authenticationMode === "IR",
                                },
                                {
                                    beginGroup: true,
                                    name: 'Logout',
                                    html: '<span class="material-icons">logout</span>',
                                },
                            ],
                        },],
                        hideSubmenuOnMouseLeave: false,
                        displayExpr: 'name',
                        onItemClick(data) {
                            switch (data.itemData.name) {
                                case "Change Password":
                                    irGlobal.changePassword();
                                    break;
                                case "Logout":
                                    window.location.href = "/Login/Logout";
                                    break;
                            }
                        },
                    },
                },
            ],
        }).dxToolbar("instance");

        let updateViewBadge = function (removing: boolean = false) {
            let recents = json.workbooks.filter(x => x.lastViewedDate).slice(0, 10).length;
            let recentMenu = (menuList.find(x => x.key === "View").items.find(x => x.key == 1) as any);
            recentMenu.badge = recents;
            $(".dx-list-item-badge.dx-badge", $("span#itemElement-1").closest(".dx-item.dx-list-item")).html(recents === 0 ? "" : recents);

            let favorites = json.workbooks.filter(x => x.workbook.favorite).length;
            let favoritesMenu = (menuList.find(x => x.key === "View").items.find(x => x.key == 2) as any);
            favoritesMenu.badge = favorites;
            $(".dx-list-item-badge.dx-badge", $("span#itemElement-2").closest(".dx-item.dx-list-item")).html(favorites === 0 ? "" : favorites);

            let all = json.workbooks.length;
            let allMenu = (menuList.find(x => x.key === "View").items.find(x => x.key == 3) as any);
            allMenu.badge = all;
            $(".dx-list-item-badge.dx-badge", $("span#itemElement-3").closest(".dx-item.dx-list-item")).html(all === 0 ? "" : all);

            if (removing && recents === 0) {
                $("span#itemElement-1").closest(".dx-item.dx-list-item").remove();
                if (vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Recent) {
                    vm.showWorkbooksMode(ShowWorkbooksModeEnum.All);
                    //Select All Workbooks
                    menuListControl.selectItem({ group: 1, item: 1 });
                }
            }
        }

        const mappingNameDataField = "mappingName";
        const ownerUserNameDataField = "ownerUserName";
        const categoryNameDataField = "categoryName";
        const lastViewedDataField = "lastViewed";
        const viewsCounterDataField = "viewsCounter";
        let vm = {
            showWorkbooksMode: ko.observable(json.showWorkbooksMode),
            showTabs: ko.observable(json.showTabs),
            showWorkbooksType: ko.observable(json.showWorkbooksType),
            grouping: ko.observable(json.grouping),
            sortColumn: ko.observable(json.sortColumn),
            sortOrder: ko.observable(json.sortOrder),
            sortByFavoriteOrder: ko.observable(json.sortByFavoriteOrder),
            editFavoriteOrder: ko.observable(false),
            filterByEmail: ko.observable(false),

            gridConfig: null,
            gridComponent: null
        } as IHomeViewModel;
        vm.gridConfig = {
            dataSource: getDataSource(),
            elementAttr: {
                class: "homeContent"
            },
            width: '100%',
            height: "calc(100vh - 40px)",
            rowAlternationEnabled: true,
            headerFilter: {
                visible: true,
                search: {
                    enabled: true
                },
            },
            columnChooser: {
                enabled: true,
                mode: "select"
            },
            keyExpr: "id",
            //columnAutoWidth: true,
            dataRowTemplate(container, item) {
                const { data } = item;

                let tabsLink = "";
                if (vm.showTabs() && !isMobile()) {

                    let count = 0;
                    data.workbook.tabs.forEach(function (tab) {
                        let icon = "glyphicon-asterisk";
                        switch (tab.tabType) {
                            case 1:
                                icon = "dashboard";
                                break;
                            default:
                                switch (tab.reportType) {
                                    case 1:
                                        icon = "list_alt";
                                        break;
                                    case 2:
                                        icon = "equalizer";
                                        break;
                                    case 3:
                                        icon = "pivot_table_chart";
                                        break;
                                }
                                break;
                        }
                        let style = tab.id == data.workbook.defaultTabId ? "color: #ffc107;" : "";
                        let separator = count > 0 ? " | " : "";

                        tabsLink += `<li>${separator}<a data-id='${tab.id}' data-wb='${data.id}'>
                                    <span class="material-icons tab-icon" aria-hidden="true" style="${style}">${icon}</span>${tab.name}
                                </a></li>`;

                        count++;
                    });
                }

                let sharedIcon = "";
                let viewOnlyIcon = "";
                let defaultWorkbook = "";
                if (data.editMode !== WorkbookEditModeEnum.Owner) {
                    let title = loggedUser.permissions.workbooks() ? "" : "Shared";
                    if (data.ownerUserName) {
                        title += `&#10;Owner: ${data.ownerUserName}`;
                    }
                    if (data.ownerEmail) {
                        title += `&#10;Email: ${data.ownerEmail}`;
                    }

                    sharedIcon = `  <i class="ms sharedIcon" title="${title}">${(loggedUser.permissions.workbooks() ? "person" : "share")}</i>`;

                    if (!loggedUser.permissions.workbooks()) {
                        if (data.editMode === WorkbookEditModeEnum.ViewOnly || data.editMode === WorkbookEditModeEnum.Restricted) {
                            let tooltip = data.editMode === WorkbookEditModeEnum.Restricted ? "Restricted" : "View Only";
                            viewOnlyIcon = `  <i title="${tooltip}" class="ms viewonly" title="${tooltip}">${(data.editMode === WorkbookEditModeEnum.Restricted ? "visibility_lock" : "visibility")}</i>`;
                        }
                    }
                }

                if (data.id === json.defaultWorkbook) {
                    defaultWorkbook = "  <span class='material-icons' style='color: #ffc107;font-size: 19px;' title='Default Workbook'>star</span>";
                }

                let lastViewed = data.lastViewed;
                if (data.lastViewed) {
                    lastViewed = moment(data.lastViewed).format(json.dateFormat);
                }
                else {
                    lastViewed = "";
                }

                const catColumn = item.columns.find(x => x.dataField === categoryNameDataField) ? 1 : 0;
                let colspan = (vm.grouping() === HomeWorkbookGroupingEnum.None ? 6 : 5) + catColumn;
                if (!item.columns.find(x => x.dataField === mappingNameDataField))
                    colspan--;
                if (!item.columns.find(x => x.dataField === ownerUserNameDataField))
                    colspan--;
                if (!item.columns.find(x => x.dataField === lastViewedDataField))
                    colspan--;
                if (!item.columns.find(x => x.dataField === viewsCounterDataField))
                    colspan--;

                let hasEmailsIcon = "";
                if (data.hasEmails) {
                    hasEmailsIcon = `  <i class="ms hasEmailsIcon" title="Emails">email</i>`;
                }

                const rowspan = data.description ? 3 : 2;
                const markup = '<tr class=\'main-row\'>'
                    + (vm.editFavoriteOrder() && vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites && vm.grouping() === HomeWorkbookGroupingEnum.None ? `<td rowspan='${rowspan}' class="dx-command-drag dx-cell-focus-disabled" dx-drag-cell="" role="gridcell" aria-colindex="1" style="text-align: center;"><span class="dx-datagrid-drag-icon"></span></td>` : "")
                    + (vm.grouping() !== HomeWorkbookGroupingEnum.None ? `<td rowspan='${rowspan}'></td>` : "")
                    + "<td>"
                    + `<div class='workbookName-container'><div class='workbookName'>${data.name}</div>${sharedIcon}${viewOnlyIcon}${defaultWorkbook}${hasEmailsIcon}</div>`
                    /*+ (data.description ? `<div class='tabDescription'>${data.description}</div>` : "")*/
                    + "</td>"
                    + (vm.grouping() !== HomeWorkbookGroupingEnum.Mapping && item.columns.find(x => x.dataField === mappingNameDataField) ? `<td>${data.mappingName}</td>` : "")
                    + (vm.grouping() !== HomeWorkbookGroupingEnum.Owner && item.columns.find(x => x.dataField === ownerUserNameDataField) ? `<td>${data.ownerUserName}</td>` : "")
                    + (vm.grouping() !== HomeWorkbookGroupingEnum.Category && item.columns.find(x => x.dataField === categoryNameDataField) ? `<td>${(data.categoryName ? data.categoryName : "")}</td>` : "")
                    + (item.columns.find(x => x.dataField === lastViewedDataField) ? `<td>${lastViewed}</td>` : "")
                    + (item.columns.find(x => x.dataField === viewsCounterDataField) ? `<td>${data.viewsCounter}</td>` : "")
                    + `<td class="dx-command-edit dx-command-edit-with-icons" role="gridcell" aria-colindex="8" style="text-align: center;">
                                ${!data.workbook.favorite ? `<a href="#" class="row-add-favorites dx-link custom-favorite dx-icon-favorites dx-link-icon" title="Add to favorites"></a>&nbsp` : ""}
                                ${data.workbook.favorite ? `<a href="#" class="row-remove-favorites dx-link dx-icon-favorites dx-link-icon" title="Remove from favorites"></a>&nbsp` : ""}
                                ${loggedUser.permissions.shareWorkbooks() && (data.editMode === WorkbookEditModeEnum.Owner || data.editMode === WorkbookEditModeEnum.EditBySharedUser || loggedUser.permissions.workbooks()) ? `<a href="#" class="row-share-workbook dx-link dx-icon-share dx-link-icon" title="Share"></a>&nbsp;` : ``}
                                ${data.editMode === WorkbookEditModeEnum.Owner || data.editMode === WorkbookEditModeEnum.EditBySharedUser || loggedUser.permissions.workbooks() ? `<a href="#" class="row-edit-workbook dx-link dx-icon-edit dx-link-icon" title="Edit"></a>&nbsp;` : ``}
                                ${data.editMode === WorkbookEditModeEnum.Owner || loggedUser.permissions.workbooks() ? `<a href="#" class="row-delete-workbook dx-link dx-icon-remove dx-link-icon" title="Delete"></a>&nbsp;` : ``}
                                </td>`
                    + '</tr>'
                    + (data.description ?
                        '<tr class=\'tab-description-row\'>'
                        + `<td colspan='${colspan}'><span class='tabDescription'>${data.description}</div></td>`
                        + '</tr>'
                        : ""
                    )
                    + (tabsLink !== "" ?
                        '<tr class=\'tab-row\'>'
                        + `<td colspan='${colspan}'><ul class='tablinks'>${tabsLink}</ul></td>`
                        + '</tr>'
                        : ""
                    );

                container.append(markup);

                $(".dx-command-edit.dx-command-edit-with-icons", container).off("click").on("click", function (e) {
                    e.stopPropagation();
                });
                $(".row-add-favorites", container).off("click").on("click", function () {
                    data.workbook.favorite = true;
                    updateViewBadge();

                    DevExpress.ui.notify({
                        message: `Workbook '${data.name}' added to favorites`,
                        type: 'info',
                        position: { my: 'right top', at: 'right top', offset: { x: -20, y: 20 } },
                        width: 300
                    });

                    item.component.repaintRows([item.component.getRowIndexByKey(item.key)]);

                    irGlobal.updateFromServer({},
                        urlConfigs.siteRoot + "Home/UpdateFavorites",
                        { workbookId: data.id, favorite: true },
                        null,
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to change favorite workbook";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true,
                        "POST",
                        false);
                });
                $(".row-remove-favorites", container).off("click").on("click", function () {
                    data.workbook.favorite = false;
                    updateViewBadge();

                    DevExpress.ui.notify({
                        message: `Workbook '${data.name}' removed to favorites`,
                        type: 'info',
                        position: { my: 'right top', at: 'right top', offset: { x: -20, y: 20 } },
                        width: 300
                    });

                    let rowIndex = item.component.getRowIndexByKey(item.key);
                    if (vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites) {//Favorites
                        item.component.deleteRow(rowIndex);
                    }
                    else {
                        item.component.repaintRows([rowIndex]);
                    }

                    irGlobal.updateFromServer({},
                        urlConfigs.siteRoot + "Home/UpdateFavorites",
                        { workbookId: data.id, favorite: false },
                        null,
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to change favorite workbook";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true,
                        "POST",
                        false);
                });
                $(".row-share-workbook", container).off("click").on("click", function () {
                    new WorkbookHelper({}, null).showShareWorkbook(data.id);
                });
                $(".row-edit-workbook", container).off("click").on("click", function () {
                    rowEditing = item;

                    ($("#WorkbookNameEditModal")[0] as any).value = data.name;
                    $("#WorkbookNameEditModal").css("border-color", "");
                    ($("#WorkbookDescriptionEditModal")[0] as any).value = data.description;

                    (document.querySelector('#WorkbookCategoryEditModal [value="' + data.categoryId + '"]') as any).selected = true;

                    ($('#modalNewWorkbookEdit') as any).modal('show');
                });
                $(".row-delete-workbook", container).off("click").on("click", function () {
                    let result = DevExpress.ui.dialog.custom({
                        title: data.name,
                        message: `Are you sure you want to delete the workbook?`,
                        buttons: [
                            {
                                text: "Yes",
                                type: 'danger',
                                onClick: function () { return true; }
                            },
                            {
                                text: "No",
                                onClick: function () { return false; }
                            }
                        ]
                    });
                    result.show().done(function (dialogResult) {
                        if (dialogResult) {
                            irGlobal.updateFromServer({},
                                urlConfigs.siteRoot + "Home/RemoveWorkbook",
                                { workbookId: data.id },
                                function () {
                                    const rowIndex = item.component.getRowIndexByKey(item.key);
                                    const index = json.workbooks.indexOf(data);
                                    json.workbooks.splice(index, 1);
                                    item.component.deleteRow(rowIndex);
                                    updateViewBadge(true);
                                },
                                function (textStatus, errorThrown, errorItem: IError) {
                                    errorItem.userMessage = "Failed to delete workbook";
                                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                                },
                                true,
                                "POST");
                        }
                    });
                });
                $(".hasEmailsIcon", container).off("click").on("click", function (e) {
                    e.stopPropagation();
                    if (!isMobile()) {
                        Ir.Components.Email.ScheduledEmailEditor.showEmailsFromWorkbook(data.mappingId, data.id, data.name, (result: ScheduledEmailResultVM) => {
                            if (result.emails.length === 0) {
                                $(".hasEmailsIcon", container).remove();
                                data.hasEmails = false;
                                if (vm.filterByEmail()) {
                                    vm.gridComponent.option("dataSource", getDataSource());
                                }
                            }
                        });
                    }
                });
            },
            columns: [
                { dataField: "workbook.favoriteOrder", caption: "order", sortOrder: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites ? "asc" : undefined, visible: false, dataType: "number", showInColumnChooser: false, allowSearch: false },
                { dataField: "id", caption: "Workbook Id", visible: false, dataType: "number", showInColumnChooser: false, allowSearch: false },
                { dataField: "editMode", visible: false, dataType: "number", showInColumnChooser: false, allowSearch: false },
                { dataField: "ownerId", visible: false, dataType: "number", showInColumnChooser: false, allowSearch: false },
                { dataField: "tabsName", visible: false, showInColumnChooser: false },
                {
                    dataField: "name",
                    caption: "Workbook",
                    dataType: "string",
                    sortOrder: json.sortColumn === "name" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    minWidth: 250,
                    allowHiding: false
                },
                {
                    dataField: "mappingName",
                    dataType: "string",
                    caption: "Mapping",
                    sortOrder: json.sortColumn === "mappingName" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    minWidth: 50,
                    width: "25%",
                    hidingPriority: isMobile() ? 0 : undefined,
                    groupIndex: json.grouping === HomeWorkbookGroupingEnum.Mapping ? 0 : undefined,
                    visible: json.showMappingColumn
                },
                {
                    dataField: "ownerUserName",
                    dataType: "string",
                    caption: "Owner",
                    sortOrder: json.sortColumn === "ownerUserName" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    minWidth: 50,
                    width: "25%",
                    hidingPriority: isMobile() ? 1 : undefined,
                    groupIndex: json.grouping === HomeWorkbookGroupingEnum.Owner ? 0 : undefined,
                    visible: json.showOwnerColumn
                },
                {
                    dataField: "categoryName",
                    dataType: "string",
                    caption: "Category",
                    sortOrder: json.sortColumn === "categoryName" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    visible: json.showCategoryColumn,
                    width: 120,
                    groupIndex: json.grouping === HomeWorkbookGroupingEnum.Category ? 0 : undefined,
                    hidingPriority: isMobile() ? 4 : undefined
                },
                {
                    dataField: "lastViewed",
                    dataType: "datetime",
                    caption: "Last Viewed",
                    sortOrder: json.sortColumn === "lastViewed" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    width: 120,
                    hidingPriority: isMobile() ? 2 : undefined,
                    cellTemplate: function (container, options) {
                        if (options.data.lastViewed) {
                            const date = moment(options.data.lastViewed).format(json.dateFormat);
                            container.append(date)
                        }
                    },
                    visible: json.showLastViewedColumn
                },
                {
                    dataField: "viewsCounter",
                    dataType: "string",
                    caption: "Views",
                    sortOrder: json.sortColumn === "viewsCounter" && json.showWorkbooksMode !== ShowWorkbooksModeEnum.Favorites ? json.sortOrder : undefined,
                    width: 70,
                    hidingPriority: isMobile() ? 3 : undefined,
                    visible: json.showViewsColumn
                },
                {
                    type: "buttons",
                    visible: isMobile() ? false : true,
                    showInColumnChooser: false,
                    buttons: [{
                        hint: "Add to favorites",
                        icon: "favorites",
                        cssClass: "custom-favorite",
                        visible: function (e) {
                            return !e.row.data.workbook.favorite;
                        }
                    }, {
                        hint: "Remove from favorites",
                        icon: "favorites",
                        visible: function (e) {
                            return e.row.data.workbook.favorite;
                        }
                    }, {
                        hint: "Share",
                        icon: "share"
                    }, {
                        hint: "Edit",
                        icon: "edit"
                    }, {
                        hint: "Delete",
                        icon: "remove"
                    }]
                },
            ],
            searchPanel: {
                visible: true,
                width: mobileDevice ? "92%" : 200,
                placeholder: 'Search...',
                searchVisibleColumnsOnly: false
            },
            scrolling: {
                mode: 'virtual'
            },
            paging: {
                enabled: false
            },
            sorting: {
                mode: 'none'
            },
            editing: {
                confirmDelete: false
            },
            noDataText: ko.computed(() => {
                return vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites ? "No Favorites" : "No Workbooks";
            }) as any,
            rowDragging: {
                allowReordering: false,
                container: $(".homeContent").first(),
                onReorder(e) {
                    const visibleRows = e.component.getVisibleRows();
                    let dataSource = e.component.getDataSource().items();
                    const toIndex = dataSource.findIndex((item) => item.id === visibleRows[e.toIndex].data.id);
                    const fromIndex = dataSource.findIndex((item) => item.id === e.itemData.id);

                    dataSource.splice(fromIndex, 1);
                    dataSource.splice(toIndex, 0, e.itemData);

                    let order = 0;
                    let input = [];
                    dataSource.forEach(function (row) {
                        //Need to resolve when it is grouping
                        if (row.workbook) {
                            row.workbook.favoriteOrder = order;
                            input.push({ workbookId: row.id, order: order });

                            order++;
                        }
                    });

                    e.component.refresh();

                    irGlobal.updateFromServer({},
                        urlConfigs.siteRoot + "Home/UpdateFavoritesOrder",
                        { workbooks: input },
                        null,
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to change favorite workbook order";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true,
                        "POST",
                        false);
                }
            },
            showColumnLines: false,
            showRowLines: true,
            showBorders: false,
            filterValue: json.showWorkbooksType === ShowWorkbooksTypeEnum.All ? undefined : json.showWorkbooksType === ShowWorkbooksTypeEnum.Mine ? ['ownerId', '=', `${loggedUser.id()}`] : json.showWorkbooksType === ShowWorkbooksTypeEnum.OtherUsers ? ['ownerId', '<>', `${loggedUser.id()}`] : ['editMode', '<>', '1'],
            onRowClick(e) {
                if (e.rowType === "data" && e.data) {
                    if (e.event.target && $(e.event.target).hasClass("sharedIcon")) {
                        irGlobal.copyTextToClipboard(e.data.ownerEmail, "Email copied to clipboard");
                        return;
                    }

                    const companyId = getCompanyId();
                    const url = `/wb/edit/${e.data.id}?loadFromDb=True`;
                    if (companyId > 0) {
                        document.location = `${url}&companyId=${companyId}`;
                    }
                    else {
                        document.location = url;
                    }
                }
            },
            onContentReady(e) {
                $('table tr ul.tablinks a', e.element).each(function () {
                    $(this).off("click").on("click", function (e) {
                        const companyId = getCompanyId();
                        const url = `/wb/edit/${$(this).data("wb")}?tabId=${$(this).data("id")}&loadFromDb=True`;
                        if (companyId > 0) {
                            document.location = `${url}&companyId=${companyId}`;
                        }
                        else {
                            document.location = url;
                        }
                    });
                });
            },
            onCellPrepared(e) {
                let column = e.column;
                if (e.rowType == 'header' && column) {
                    e.cellElement.on('click', function (evt) {
                        if (vm.sortByFavoriteOrder() && vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites) {
                            return;
                        }

                        vm.sortOrder("");
                        vm.sortColumn("");

                        let sortOrder = !e.column.sortOrder ? "desc" : e.column.sortOrder === "desc" ? "asc" : undefined;
                        e.component.beginUpdate();
                        e.component.clearSorting();
                        if (sortOrder) {
                            e.component.columnOption(column.dataField, "sortOrder", sortOrder);

                            vm.sortOrder(sortOrder);
                            vm.sortColumn(column.dataField);
                        }
                        e.component.endUpdate();

                        updateUserPreferences();
                    });
                }
            },
            onContextMenuPreparing(e) {
                if (e.target === "content") {
                    if (!e.items) {
                        e.items = [];
                    }

                    e.items.push({
                        text: "Expand All",
                        onItemClick: function () {
                            e.component.expandAll();
                        }
                    });
                    e.items.push({
                        text: "Collapse All",
                        onItemClick: function () {
                            e.component.collapseAll();
                        }
                    });
                }
            },
            onOptionChanged(e) {
                if (e.fullName && e.fullName.match(/columns\[\d+\].visible/g)) {
                    //Column Chooser changed
                    //let idxColumn = parseInt(e.fullName.match(/\d+/g));
                    //let column = e.component.option("columns")[idxColumn];
                    updateUserPreferences();
                }
            },
            onInitialized(e) {
                vm.gridComponent = e.component;
            },
            toolbar: {
                items: [{
                    name: "expandCollapse",
                    location: "before",
                    widget: 'dxButton',
                    options: {
                        icon: "collapse",
                        hint: "Collapse All",
                        onClick(e) {
                            const expanding = e.component.option('icon') === 'expand';
                            $("#homeWorkbookGrid").dxDataGrid("instance").option('grouping.autoExpandAll', expanding);
                            e.component.beginUpdate();
                            e.component.option('icon', expanding ? 'collapse' : 'expand');
                            e.component.option('hint', expanding ? 'Collapse All' : 'Expand All');
                            e.component.endUpdate();
                        },
                        visible: json.grouping !== HomeWorkbookGroupingEnum.None
                    }
                }, {
                    name: "sortByFavorite",
                    location: "before",
                    widget: 'dxButton',
                    options: {
                        icon: "orderedlist",
                        hint: "Sort by Favorite",
                        elementAttr: {
                            class: json.sortByFavoriteOrder ? "dx-state-selected" : ""
                        },
                        onClick(e) {
                            vm.sortByFavoriteOrder(!vm.sortByFavoriteOrder());
                            if (vm.sortByFavoriteOrder()) {
                                e.element.addClass("dx-state-selected");
                            }
                            else {
                                e.element.removeClass("dx-state-selected");
                            }

                            e.element.removeClass("dx-state-focused");
                        },
                        visible: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites
                    }
                }, {
                    name: "editFavoriteOrder",
                    location: "before",
                    widget: 'dxButton',
                    options: {
                        icon: "sorted",
                        hint: "Edit Favorite Order",
                        onClick(e) {
                            vm.editFavoriteOrder(!vm.editFavoriteOrder());
                            if (vm.editFavoriteOrder()) {
                                e.element.addClass("dx-state-selected");
                            }
                            else {
                                e.element.removeClass("dx-state-selected");
                            }

                            e.element.removeClass("dx-state-focused");
                        },
                        visible: json.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites
                    }
                }, {
                    location: "after",
                    name: "searchPanel"
                }, {
                    location: "after",
                    name: "columnChooserButton",
                    visible: !mobileDevice
                }, {
                    location: "after",
                    widget: 'dxButton',
                    options: {
                        icon: "email",
                        hint: "Filter Workbooks by Email",
                        onClick(e) {
                            vm.filterByEmail(!vm.filterByEmail());
                            vm.gridComponent.option("dataSource", getDataSource());

                            if (vm.filterByEmail()) {
                                e.element.addClass("dx-state-selected");
                            }
                            else {
                                e.element.removeClass("dx-state-selected");
                            }
                        }
                    }
                }]
            }
        } as DevExpress.ui.dxDataGrid.Properties;

        let updateUserPreferences = function () {
            let columns = $("#homeWorkbookGrid").dxDataGrid("instance").getVisibleColumns();
            irGlobal.updateFromServer({},
                urlConfigs.user + "UpdateUserPreferences",
                {
                    showTabs: vm.showTabs(),
                    showWorkbooksType: vm.showWorkbooksType(),
                    workbookGrouping: vm.grouping(),
                    showWorkbooksMode: vm.showWorkbooksMode(),
                    sortColumn: vm.sortColumn(),
                    sortOrder: vm.sortOrder(),
                    sortByFavoriteOrder: vm.sortByFavoriteOrder(),
                    showMappingColumn: columns.find(x => x.dataField === mappingNameDataField) ? true : false,
                    showOwnerColumn: columns.find(x => x.dataField === ownerUserNameDataField) ? true : false,
                    showCategoryColumn: columns.find(x => x.dataField === categoryNameDataField) ? true : false,
                    showLastViewedColumn: columns.find(x => x.dataField === lastViewedDataField) ? true : false,
                    showViewsColumn: columns.find(x => x.dataField === viewsCounterDataField) ? true : false
                },
                undefined,
                function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to save user preferences";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                },
                true,
                "POST",
                false);
        }
        vm.showTabs.subscribe(updateUserPreferences);
        vm.showWorkbooksType.subscribe(updateUserPreferences);
        vm.grouping.subscribe(updateUserPreferences);
        updateGridTitle(vm);

        let updateWorkbooksModeAndSortFavorites = function () {
            updateUserPreferences();

            let dataGrid = $("#homeWorkbookGrid").dxDataGrid("instance");
            dataGrid.beginUpdate();
            dataGrid.option("rowDragging.allowReordering", vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites && vm.editFavoriteOrder());

            dataGrid.clearSorting();
            if (vm.showWorkbooksMode() === ShowWorkbooksModeEnum.Favorites && vm.sortByFavoriteOrder()) {
                dataGrid.columnOption("workbook.favoriteOrder", "sortOrder", "asc");
            }
            else {
                dataGrid.columnOption(vm.sortColumn(), "sortOrder", vm.sortOrder());
            }

            dataGrid.endUpdate();
        }

        vm.showWorkbooksMode.subscribe(updateWorkbooksModeAndSortFavorites);
        vm.sortByFavoriteOrder.subscribe(updateWorkbooksModeAndSortFavorites);
        vm.editFavoriteOrder.subscribe(updateWorkbooksModeAndSortFavorites);

        ko.applyBindings(vm, $(".homeContent").get(0));

        if (isMobile()) {
            $(".loginContainer .dropdown").off('show.bs.dropdown').on('show.bs.dropdown', function () {
                let dropDownAddFilter = $('.dropdown-menu', $(this));
                let addButtonPosition = $(this).parent().get(0).getBoundingClientRect();
                let top = addButtonPosition.bottom;
                top -= (dropDownAddFilter.outerHeight() + $(this).parent().outerHeight());

                dropDownAddFilter.css({ "position": "fixed", "left": `${(addButtonPosition.left + $(this).parent().width() - dropDownAddFilter.width()) - 10}px`, "top": `0px` });
            });
        }
    }
    var saveWorkbook = function (e) {
        if (e)
            e.preventDefault();

        var inputName = $("#WorkbookNameEditModal");
        var workbookName = (inputName[0] as any).value;
        var workbookDescription = ($("#WorkbookDescriptionEditModal")[0] as any).value;
        var workbookCategory = $("#WorkbookCategoryEditModal")[0] as any;
        var workbookCategoryId = workbookCategory.value;
        var workbookCategoryName = workbookCategory.options[workbookCategory.selectedIndex].text;

        var submitObj = {
            name: workbookName,
            id: rowEditing.data.id,
            description: workbookDescription,
            categoryId: workbookCategoryId,
            categoryName: workbookCategoryName
        };

        var completeFunction = function (data) {
            inputName.val(data.name);
            if (data.isNameUnique) {
                const dataGrid = $("#homeWorkbookGrid").dxDataGrid("instance");
                rowEditing.data.name = data.name;
                rowEditing.data.description = data.description;
                rowEditing.data.categoryId = data.categoryId;
                rowEditing.data.categoryName = data.categoryName;
                //dataGrid.repaintRows([dataGrid.getRowIndexByKey(rowEditing.key)]);
                dataGrid.refresh(true);

                ($('#modalNewWorkbookEdit') as any).modal('hide');
            }
            else {
                inputName.focus();
                inputName.css("border-color", "indianred");
                irGlobal.notifyError("Duplicated name, please choose another name.");
            }
        };

        var url = urlConfigs.siteRoot + "EditWorkbook";
        irGlobal.updateFromServer(e,
            url,
            submitObj,
            completeFunction,
            function (textStatus, errorThrown, errorItem: IError) {
                errorItem.userMessage = "Failed to save workbook";
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            },
            true,
            "POST",
            true);

        return false;
    };

    return {
        setup: setup,
        saveWorkbook: saveWorkbook
    };
})();